import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookMarked, Printer, ArrowRight } from "lucide-react";
import api from "@/lib/api";

const DEFAULTS = {
  eyebrow: "Presses universitaires",
  title: "PUSIC — Presses Universitaires des Sciences de l'Information et de la Communication",
  banner_image: "/media/modern-library.jpg",
  intro:
    "Les PUSIC sont l'organe éditorial officiel de l'UNISIC. Elles éditent et diffusent les productions scientifiques (revues, notes de cours, essais, ouvrages) des enseignants-chercheurs, valorisant ainsi la recherche et la pensée congolaise en sciences de l'information et de la communication.",
};

const BLOCKS = [
  {
    key: "publications",
    to: "/directions/bibliotheques-musees/pusic/publications",
    Icon: BookMarked,
    color: "#0A2E52",
    eyebrow: "Catalogue éditorial",
    title: "Publications universitaires",
    desc: "Catalogue complet des ouvrages, revues, notes de cours, essais et romans édités par les PUSIC.",
    banner: "/media/digital-library.jpg",
  },
  {
    key: "reproduction",
    to: "/directions/bibliotheques-musees/pusic/reproduction",
    Icon: Printer,
    color: "#D4AF37",
    eyebrow: "Reproduction et impression",
    title: "Unité de Reproduction des Travaux Académiques",
    desc: "Impression officielle des travaux académiques après Bon à Imprimer (B.A.T) du Secrétariat Général.",
    banner: "/media/museum-publications.jpg",
  },
];

export default function Pusic() {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/content/pusic.home").then((r) => setContent({ ...DEFAULTS, ...(r.data || {}) })).catch(() => {});
  }, []);

  return (
    <div data-testid="pusic-hub">
      <section className="relative h-[46vh] min-h-[340px] overflow-hidden">
        <img src={content.banner_image} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-veil" />
        <div className="relative h-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col justify-end pb-14">
          <div className="eyebrow" style={{ color: "#E5C158" }}>{content.eyebrow}</div>
          <h1 className="mt-3 text-white text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-4xl">
            {content.title}
          </h1>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-unisic-gold" />
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="eyebrow eyebrow-dark">Mission éditoriale</div>
        <span className="divider-gold mt-3" />
        <p className="mt-6 text-lg text-slate-700 leading-relaxed max-w-4xl whitespace-pre-line">
          {content.intro}
        </p>

        <div className="mt-14 grid gap-8 md:grid-cols-2">
          {BLOCKS.map((b) => (
            <Link key={b.key} to={b.to} className="group paper-card card-hover overflow-hidden flex flex-col" data-testid={`pusic-block-${b.key}`}>
              <div className="relative h-52 overflow-hidden">
                <img src={b.banner} alt="" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="inline-flex items-center justify-center w-10 h-10 rounded-sm mb-2" style={{ background: b.color, color: "#fff" }}>
                    <b.Icon className="w-5 h-5" />
                  </div>
                  <div className="text-[11px] tracking-[0.28em] uppercase text-white/85 font-semibold">{b.eyebrow}</div>
                  <h3 className="text-white text-xl font-bold mt-1 leading-tight">{b.title}</h3>
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <p className="text-sm text-slate-600 leading-relaxed flex-1">{b.desc}</p>
                <div className="mt-5 inline-flex items-center gap-2 text-unisic-blue font-semibold text-sm group-hover:text-unisic-gold transition-colors">
                  Ouvrir <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
